import React, { useEffect, useRef } from 'react'
import { COPY_STRINGS } from '../../../../constants/translatedCopy'
import { amiraGestures } from '../../../Coach/GesturedSpeech'
import { PRE_CHECK_MACHINE_STATES } from '../../constants'
import useStudentPreChecks from '../../useStudentPreChecks'
import { MAX_COUNT_TO_REMIND_STUDENT_TO_SPEAK, MS_TO_WAIT_BETWEEN_REMIND_STUDENT_TO_SPEAK, VOLUME_CHECK_EVENTS } from '../StudentVolumeChecksConstants'

export default function VolumeInitialReminders(props) {

    const { speechProps, isTeacherMode, setShowTeacherTroubleshootScreen } = props

    const { logEvent } = useStudentPreChecks({ itemToCheck: PRE_CHECK_MACHINE_STATES.studentSpeechVolumeChecks })

    const remindInitialSpeechTimer = useRef()
    const remindStudentCount = useRef(0)

    useEffect(()=>{
        startRemindInitialSpeechTimer()

        return () => {
            cancelRemindInitialSpeechTimer()
            speechProps.abortSpeech()
        }

    }, [])

    const startRemindInitialSpeechTimer = async () => {
        cancelRemindInitialSpeechTimer()

        const remind = () => {
            reminderSpeech()
        }
        if(remindStudentCount.current <= MAX_COUNT_TO_REMIND_STUDENT_TO_SPEAK){
            if(isTeacherMode){
                logEvent(VOLUME_CHECK_EVENTS.TEACHER_PROMPT_TO_SPEAK)
            }else{
                logEvent(VOLUME_CHECK_EVENTS.STUDENT_PROMPT_TO_SPEAK)
            }

            remindInitialSpeechTimer.current = setTimeout(() => {
                remind()
            }, MS_TO_WAIT_BETWEEN_REMIND_STUDENT_TO_SPEAK)
        }
    }

    const cancelRemindInitialSpeechTimer = async () => {
        clearTimeout(remindInitialSpeechTimer.current)
    }

    const reminderSpeech = async () => {
        if(isTeacherMode){
            if(remindStudentCount.current === 0){
                await speechProps.speakWithPromise({textToSpeak: COPY_STRINGS.student_checks.handle_no_audio_one})
                await speechProps.speakWithPromise({ textToSpeak: COPY_STRINGS.student_checks.handle_no_audio_part_two })
                await speechProps.speakWithPromise({ textToSpeak: COPY_STRINGS.student_checks.wake_up_spot })
                startRemindInitialSpeechTimer()
            }else{
                // cancelAllTimers()
                await speechProps.speakWithPromise({ textToSpeak: COPY_STRINGS.student_checks.teacher_mode_volume_failure_one })
                setShowTeacherTroubleshootScreen(true)
            }
        }else{
            if (remindStudentCount.current === 0) {
                await speechProps.speakWithPromise({ textToSpeak: COPY_STRINGS.student_checks.handle_no_audio_one })
                await speechProps.speakWithPromise({ textToSpeak: COPY_STRINGS.student_checks.handle_no_audio_part_two })
                speechProps.playDance({
                    gesture: amiraGestures.SweepWave
                })
                await speechProps.speakWithPromise({ textToSpeak: COPY_STRINGS.student_checks.wake_up_spot })
                startRemindInitialSpeechTimer()
            } else if (remindStudentCount.current === 1) {
                await speechProps.speakWithPromise({ textToSpeak: COPY_STRINGS.student_checks.handle_no_audio_two })
                startRemindInitialSpeechTimer()
            }
            else if (remindStudentCount.current === 2) {
                await speechProps.speakWithPromise({ textToSpeak: COPY_STRINGS.student_checks.handle_get_teacher })
                setShowTeacherTroubleshootScreen(true)
            }
        }
        remindStudentCount.current = remindStudentCount.current + 1
    }
    
  return null
}
